import React from "react";
import Container from "react-bootstrap/Container";
import { Spinner } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import HSAxios from "../HSAxios";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { MdSentimentDissatisfied } from "react-icons/md";
import { 
  FaExclamationCircle, 
  FaUser, 
  FaUsers,
  FaHome, 
  FaCalendarAlt, 
  FaPhoneAlt, 
  FaEye,
  FaCheckCircle,
  FaClock
} from "react-icons/fa";
import PaymentStatusModal from "./PaymentStatusModal";
import { Modal } from "react-bootstrap";
import axiosInstance from "../HSAxios";

export default function Leads() {
  const [hostelLead, setHostelLead] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [show, setShow] = useState(null);
  const [visibleNumbers, setVisibleNumbers] = useState({});
  const [index, setIndex] = useState(null);
  const [msg, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const [btnTitle, setBtnTitle] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [customModalShow, setCustomModalShow] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("token");
    console.log(token);

    if (!token) {
      console.log("Not logged in");
      navigate("/login", {});

      return;
    }

    HSAxios.get("https://api.hostelduniya.com/api/owner/myschedule")
      .then((response) => {
        setHostelLead(response.data);
        setLoading(false);
        console.log(response.data);
      })
      .catch((err) => {
        console.log("authentication error ", err);
        if (err.response && err.response.status === 401) {
          //   Cookies.remove("token");
          //   navigate("/login");
        }
      });
  }, [navigate]);

  const handleClick = (idx) => {
    HSAxios.get(
      `api/get/leads/number?scheduleId=${hostelLead[idx].schedule_id}`
    )
      .then((response) => {
        console.log(response);
        
        // Check if response has an error message
        if (response.message && typeof response.message === 'string') {
          setShow(true);
          setTitle("Error");
          setMsg(response.message);
          setIsSubscribed(false);
          setBtnTitle(null);
          setIsSuccess(false);
          return;
        }
        
        // Check if result is an array (success case)
        if (Array.isArray(response.result) && response.result.length > 0) {
          const phoneNumber = response.result[0]?.phone_number || "Unknown";
          setIndex(idx);
          setVisibleNumbers((prev) => ({ ...prev, [idx]: phoneNumber }));
        } else {
          // Subscription expired or not subscribed
          setShow(true);
          setTitle("Buy Subscription!");
          setIsSubscribed(false);
          setBtnTitle("Subscribe");
        }
        console.log(show, title, msg, isSubscribed);
      })
      .catch((err) => {
        console.error("Error fetching lead number:", err);
        setShow(true);
          setTitle("Error");
          setMsg(err.response?.data?.message || err.message || "Failed to fetch contact details. Please try again.");
          setIsSubscribed(false);
          setBtnTitle(null);
          setIsSuccess(false);
      });
  };

  useEffect(() => {
    console.log("visible numbersssss,", visibleNumbers);
  }, [visibleNumbers]);
  console.log(visibleNumbers);
  const closeModal = () => {
    setShow(false);
    setCustomModalShow(false);
  };
  let handler = () => {
    navigate("/payment", { state: { origin: "leads" } });
  };

  const paymentHandler = async (idx) => {
    setShow(false);
    // setTimeout(() => setCustomModalShow(true), 700);

    console.log("pay button is clicked");
    // make a api request and for deducting 20 rupees
    // 20 rupees deducted
    // i will give hostel data like id and owner data
    // i will receive if the person has sufficient amount or not, If sufficient amount then i will receive number in the response and status code of 7001
    const amount = 20;
    const res = await axiosInstance.get(
      `https://api.hostelduniya.com/api/wallet/payment?amount=${amount}&scheduleId=${hostelLead[idx].schedule_id}`
    );

    if (res.status === 7001) {
      setVisibleNumbers((prev) => ({
        ...prev,
        [index]: hostelLead[index].phone_number,
      }));
      setMsg(
        `${amount} Rupees is deducted from you wallet. Remaing balance is ${res.remaining_balance} rupees`
      );
      setIsSubscribed(true);
      setTitle("Payment Successful");
      setBtnTitle(null);
      setCustomModalShow(true);
      setIsSuccess(true);

      // closeModal();
    } else {
      setMsg(`${res.message}! Please Add Money.`);
      setBtnTitle("Add Money");
      setTitle("Insufficient Amount");
      setIsSuccess(false);
      setCustomModalShow(true);
    }
  };

  const subscriptionHandler = (idx) => {
    setIndex(idx);
    handleClick(idx);
  };
  console.log(index);
  const onClose = () => {
    setShow(false);
  };

  return (
    <>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading leads...
          </p>
        </div>
      )}
      {!loading && (
        <Container style={{ padding: "40px 20px", minHeight: "calc(100vh - 200px)" }}>
          {/* Header Section */}
          <div className="text-center mb-5">
            <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid #760B0B",
                  boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                }}
              >
                <FaUsers style={{ fontSize: "28px", color: "#760B0B" }} />
              </div>
              <h2
                className="fw-bold mb-0"
                style={{
                  color: "#760B0B",
                  fontSize: "36px",
                  letterSpacing: "1.5px",
                  textShadow: "0 2px 4px rgba(118, 11, 11, 0.1)",
                }}
              >
                LEADS
              </h2>
            </div>
            <p className="text-muted" style={{ fontSize: "16px" }}>
              Manage and view your student leads
            </p>
          </div>

          {hostelLead.length === 0 && (
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{ minHeight: "60vh" }}
            >
              <div className="text-center">
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    backgroundColor: "#f8f9fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 30px",
                    border: "3px solid #e0e0e0",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <MdSentimentDissatisfied
                    style={{ fontSize: "60px", color: "#8B0000" }}
                  />
                </div>
                <h2 className="fw-bold mb-3" style={{ color: "#333" }}>
                  No Leads Available
                </h2>
                <p className="text-muted" style={{ fontSize: "18px" }}>
                  Check back soon for new leads!
                </p>
              </div>
            </div>
          )}
          {hostelLead.length > 0 && (
            <>
            <PaymentStatusModal
              show={customModalShow}
              title={title}
              msg={msg}
              btnTitle={btnTitle}
              handler={handler}
              onClose={closeModal}
              isSuccess={isSuccess}
            />
            <Modal
              show={show}
              onHide={onClose}
              centered
              style={{
                borderRadius: "20px",
              }}
            >
              <Modal.Header
                closeButton
                style={{
                  borderBottom: "2px solid #ffc107",
                  backgroundColor: "#fffbf0",
                  borderRadius: "20px 20px 0 0",
                  padding: "20px 25px",
                }}
              >
                <Modal.Title
                  style={{
                    color: "#856404",
                    fontWeight: "700",
                    fontSize: "20px",
                  }}
                >
                  {title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "30px 25px" }}>
                <div className="text-center">
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      backgroundColor: "#fff3cd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                      animation: "scaleIn 0.3s ease-out",
                    }}
                  >
                    <FaExclamationCircle
                      style={{
                        fontSize: "50px",
                        color: "#ffc107",
                      }}
                    />
                  </div>
                  <p
                    style={{
                      color: "#856404",
                      fontSize: "16px",
                      lineHeight: "1.6",
                      fontWeight: "500",
                      marginBottom: "25px",
                    }}
                  >
                    Your subscription has been expired. To continue enjoying
                    this service, please renew your subscription.
                  </p>
                  <div className="d-flex flex-column gap-3 align-items-center">
                    <Button
                      variant="primary"
                      onClick={handler}
                      className="fw-semibold px-5 py-2"
                      style={{
                        borderRadius: "10px",
                        fontSize: "16px",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
                        width: "200px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 20px rgba(0, 123, 255, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(0, 123, 255, 0.3)";
                      }}
                    >
                      Subscribe
                    </Button>
                    <div className="d-flex align-items-center gap-2 my-2">
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#e0e0e0",
                        }}
                      ></div>
                      <span
                        style={{
                          color: "#999",
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        OR
                      </span>
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#e0e0e0",
                        }}
                      ></div>
                    </div>
                    <p
                      style={{
                        color: "#856404",
                        fontSize: "15px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }}
                    >
                      Pay ₹20 to view this number!
                    </p>
                    <Button
                      variant="success"
                      onClick={() => paymentHandler(index)}
                      className="fw-semibold px-5 py-2"
                      style={{
                        borderRadius: "10px",
                        fontSize: "16px",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 15px rgba(40, 167, 69, 0.3)",
                        width: "200px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 20px rgba(40, 167, 69, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
                      }}
                    >
                      Pay ₹20
                    </Button>
                  </div>
                </div>
              </Modal.Body>
              <style>
                {`
                  @keyframes scaleIn {
                    from {
                      transform: scale(0);
                      opacity: 0;
                    }
                    to {
                      transform: scale(1);
                      opacity: 1;
                    }
                  }
                  .modal-content {
                    border-radius: 20px !important;
                    border: none !important;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
                  }
                  .modal-header .btn-close {
                    font-size: 18px;
                    opacity: 0.6;
                    transition: opacity 0.3s ease;
                  }
                  .modal-header .btn-close:hover {
                    opacity: 1;
                  }
                `}
              </style>
            </Modal>
            <Row className="g-4">
              {hostelLead.map((hostelLeadDetail, idx) => {
                const isInterested = hostelLeadDetail.status === "INTERESTED";
                const isNumberVisible = visibleNumbers[idx];
                
                return (
                  <Col md={4} key={idx}>
                    <Card
                      className="border-0 shadow-lg h-100"
                      style={{
                        background: isInterested
                          ? "linear-gradient(135deg, #fcf2f9 0%, #f8e8f3 100%)"
                          : "linear-gradient(135deg, #e4eff5 0%, #d4e7f0 100%)",
                        color: "#212529",
                        borderRadius: "20px",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        cursor: "pointer",
                        border: isInterested ? "2px solid #ff6b9d" : "2px solid #4A90E2",
                        overflow: "hidden",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-8px)";
                        e.currentTarget.style.boxShadow = isInterested
                          ? "0 15px 40px rgba(255, 107, 157, 0.3)"
                          : "0 15px 40px rgba(74, 144, 226, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.1)";
                      }}
                    >
                      {/* Status Badge */}
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          backgroundColor: isInterested ? "#ff6b9d" : "#4A90E2",
                          color: "white",
                          fontSize: "12px",
                          fontWeight: "600",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {isInterested ? (
                          <>
                            <FaCheckCircle style={{ fontSize: "10px" }} />
                            Interested
                          </>
                        ) : (
                          <>
                            <FaClock style={{ fontSize: "10px" }} />
                            Schedule Visit
                          </>
                        )}
                      </div>

                      <Card.Body className="p-4">
                        <div className="mb-3">
                          <div
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "12px",
                              background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px solid #760B0B",
                              marginBottom: "15px",
                            }}
                          >
                            <FaUser style={{ fontSize: "24px", color: "#760B0B" }} />
                          </div>
                          <h3 className="mb-2 fw-bold" style={{ color: "#760B0B", fontSize: "22px" }}>
                            {hostelLeadDetail.student_name}
                          </h3>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <FaHome style={{ color: "#666", fontSize: "16px" }} />
                            <h5 className="mb-0 fw-semibold" style={{ color: "#333", fontSize: "16px" }}>
                              {hostelLeadDetail.name}
                            </h5>
                          </div>
                        </div>

                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-2">
                            <FaCalendarAlt style={{ color: "#666", fontSize: "14px" }} />
                            <p className="mb-0" style={{ color: "#666", fontSize: "14px" }}>
                              <strong>Scheduled on:</strong>{" "}
                              <span className="ms-1">{hostelLeadDetail.schedule_date}</span>
                            </p>
                          </div>
                        </div>

                        <div className="mt-4 pt-3" style={{ borderTop: "1px solid rgba(0,0,0,0.1)" }}>
                          <div className="d-flex justify-content-between align-items-center gap-3">
                            <Button
                              variant={isInterested ? "success" : "primary"}
                              className="fw-semibold d-flex align-items-center gap-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                subscriptionHandler(idx);
                              }}
                              style={{
                                borderRadius: "12px",
                                padding: "10px 20px",
                                transition: "all 0.3s ease",
                                fontSize: "14px",
                                flex: 1,
                                boxShadow: isInterested
                                  ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                                  : "0 4px 12px rgba(0, 123, 255, 0.3)",
                                position: "relative",
                                zIndex: 10,
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow = isInterested
                                  ? "0 6px 16px rgba(40, 167, 69, 0.4)"
                                  : "0 6px 16px rgba(0, 123, 255, 0.4)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = isInterested
                                  ? "0 4px 12px rgba(40, 167, 69, 0.3)"
                                  : "0 4px 12px rgba(0, 123, 255, 0.3)";
                              }}
                            >
                              <FaEye />
                              View Contact
                            </Button>
                          </div>
                          
                          <div
                            className="mt-3 p-3 d-flex align-items-center justify-content-center gap-2"
                            style={{
                              backgroundColor: isNumberVisible ? "#fff5f5" : "#f8f9fa",
                              borderRadius: "12px",
                              border: isNumberVisible ? "2px solid #760B0B" : "2px solid #e0e0e0",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <FaPhoneAlt style={{ color: "#760B0B", fontSize: "18px" }} />
                            <span
                              className="fw-bold"
                              style={{
                                filter: isNumberVisible ? "none" : "blur(5px)",
                                color: "#760B0B",
                                fontSize: "16px",
                                transition: "all 0.3s ease",
                              }}
                            >
                              {isNumberVisible
                                ? `+91 ${visibleNumbers[idx]}`
                                : "+91 9xxxxxxxxx"}
                            </span>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
            </>
          )}
        </Container>
      )}
    </>
  );
}
